import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Da Vinci - The Genius",
  "description": "",
  "published": "2013-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/da-vinci-the-genius/swizec/6019"],
  "categories": "Leonardo Da Vinci, Ljubljana, Machine, Renaissance, Saturday, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last Saturday I got a chance to visit the new `}<a parentName="p" {...{
        "href": "http://davinci.si"
      }}>{`Da Vinci - The Genius`}</a>{` exhibition at `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0555555556,14.5083333333&spn=0.1,0.1&q=46.0555555556,14.5083333333%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{`'s main `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Convention_center",
        "title": "Convention center"
      }}>{`exhibition hall`}</a>{` area thing ... space?`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2013/02/da-vinci-entrance.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2013/02/da-vinci-entrance-1024x764.jpg",
          "alt": "Da Vinci Entrance",
          "title": "Da Vinci Entrance"
        }}></img></a></p>
    <p>{`It was really fun! Perhaps not as much as the one I was to in primary school, but that's just the age difference talking, really. When you are ten years old, Leonardo is this magnificent guy, half god half human, he can create anything and everything - things you could never even think of!`}</p>
    <p>{`Naturally, you use a lot of his influences in your own work - yes I used to design strange devices when I was ten years old, never build anything of course. A great inspiration.`}</p>
    <p>{`At 25 he turns into a curiosity. You appreciate the things he designed because of the times he was living in. The machines look cool, but it is painfully obvious that almost none would ever work - the flying machines especially seem kind of laughable looked at from the present time.`}</p>
    <p>{`Men flapping wooden wings ... four men running in a tight circle to screw into the air, I mean seriously.`}</p>
    <p>{`If you can't remember being a nerdy kid, completely enthralled by simple mechanics and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Classical_mechanics",
        "title": "Classical mechanics"
      }}>{`Newtonian physics`}</a>{`, just watch an episode of `}<a parentName="p" {...{
        "href": "http://www.imdb.com/title/tt0312109/",
        "title": "Codename: Kids Next Door"
      }}>{`Codename: Kids Next Door`}</a>{`. It's all there.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/da-vinci-vertical-takeoff-764x1024.jpg",
        "alt": "Da Vinci's wing flappy vertical takeoff machine.",
        "title": "Da Vinci's wing flappy vertical takeoff machine."
      }}></img></p>
    <p>{`Seriously though, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Leonardo_da_Vinci",
        "title": "Leonardo da Vinci"
      }}>{`Leonardo Da Vinci`}</a>{` was an incredibly cool guy, the prototypical renaissance man. We need more of those.`}</p>
    <p>{`His work in studying `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Human_anatomy",
        "title": "Human anatomy"
      }}>{`human anatomy`}</a>{` was ground breaking - did you know one of the paramount textbooks on anatomy, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gray%27s_anatomy"
      }}>{`Gray's Anatomy`}</a>{`, purposefully mimics his style for the sketches? - his artistic works are pretty awesome as well, but they do suffer from problems common to the era.`}</p>
    <p>{`Can somebody please tell me why artists in the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Renaissance",
        "title": "Renaissance"
      }}>{`renaissance era`}</a>{` thought women are just men with two perfectly round spheres on their chest? It's ridiculous.`}</p>
    <p>{`Either way, the exhibition is a leisurely two hour stroll through sheer awesome. You even get to play with some models!`}</p>
    <p>{`My favourite exhibit was the deceptively simple hygrometer. Put a weight on one side of a scale, some cotton on the other. Scale moves depending on how soaked in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Water_vapor",
        "title": "Water vapor"
      }}>{`water vapour`}</a>{` the cotton becomes. How cool is that!?`}</p>
    <p>{`If you're even remotely interested in mechanical things, details about the Mona Lisa or cool looking anatomical sketches, you should visit this show on a lazy afternoon.`}</p>
    <p>{`But definitely bring someone along who hasn't played with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Machine",
        "title": "Machine"
      }}>{`mechanical devices`}</a>{` and stuff a lot. The exhibition is much more interesting when you get to help somebody understand why this or that machine works or why it doesn't.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/da-vinci-robot-764x1024.jpg",
        "alt": "All you need for a humanoid robot",
        "title": "All you need for a humanoid robot"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/da-vinci-art-1024x764.jpg",
        "alt": "Da Vinci art thumbnails",
        "title": "Da Vinci art thumbnails"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://chasepage.net/2013/02/06/37/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/143343807_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://chasepage.net/2013/02/06/37/"
        }}>{`Leonardo Da Vinci`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/batman-and-leonardo-da-vinci-common-links-2013-1"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/136423848_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.businessinsider.com/batman-and-leonardo-da-vinci-common-links-2013-1"
        }}>{`'Dark Knight Trilogy' Writer Says Batman And Leonardo Da Vinci Are More Alike Than You Think`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://christcenteredteaching.wordpress.com/2012/12/31/everything-connects-to-everything-else-leonardo-da-vinci/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/135252313_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://christcenteredteaching.wordpress.com/2012/12/31/everything-connects-to-everything-else-leonardo-da-vinci/"
        }}>{`Everything Connects to Everything Else ~ Leonardo da Vinci ~`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://maphead.wordpress.com/2013/02/24/reading-the-renaissance-the-renaissance-from-greenhaven-press/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/147734613_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://maphead.wordpress.com/2013/02/24/reading-the-renaissance-the-renaissance-from-greenhaven-press/"
        }}>{`Reading the Renaissance: The Renaissance from Greenhaven Press`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://scottmdewey.wordpress.com/2013/02/25/overused-words/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/147835963_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://scottmdewey.wordpress.com/2013/02/25/overused-words/"
        }}>{`Top 3 Most Overused Words I Hate`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7643b8b1-54f5-403f-9b79-a6b617d96da0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      